export const useStyles = (theme) => ({
  root: {
    paddingLeft: 10,
    paddingRight: 10,
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: 20,
  },
  fieldStyle: {
    display: "flex",
    [theme.breakpoints.down(650)]: {
      flexDirection: "column",
    },
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingRight: 10,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  buttonStyle: {
    backgroundColor: "#004f70 !important",
    borderRadius: 20,
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#004f70 !important",
      color: "#000",
    },
  },
});
